const projects = [
  {
    id: 0,
    img: "img1",
    name: "IDC",
    description: "We Provide the most affordable and accurate medical services",
    status: "Completed",
    color: "success",
    dueDate: "2022-10-15",
    commentsCount: 214,
    team: [
      {
        id: 1,
        img: "avatar4",
        fullname: "Janice Be",
        skills: [
          { id: 1, name: "Frontend" },
          { id: 2, name: "UI" },
        ],
      },
      {
        id: 2,
        img: "avatar5",
        fullname: "Steve Foster",
        skills: [{ id: 1, name: "UI/UX" }],
      },
      {
        id: 3,
        img: "Null",
        name: "A",
        color: "success",
        fullname: "Aeffrey Walker",
        skills: [{ id: 1, name: "Backend" }],
      },
      {
        id: 4,
        img: "avatar2",
        fullname: "Daniel Candles",
        skills: [
          { id: 1, name: "Frontend" },
          { id: 2, name: "UI" },
        ],
      },
      {
        id: 5,
        img: "avatar6",
        fullname: "Steve Foster",
        skills: [{ id: 1, name: "UI/UX" }],
      },
    ],
    startDate: "10 Sept, 2015",
    projectDetails: {
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem",
      points: [
        "For Best Quality Service, it is necessary",
        "We Provide Home Sampling Services.",
        "We Provide Communication Services",
      ],
    },
    files: [
      {
        name: "Medical Board Health Care Certificate.Zip",
        size: "3.25 MB",
        link: "#",
      },
      { name: "PAK Sehat Certificate.Zip", size: "3.15 MB", link: "#" },
    ],
    comments: [
      {
        id: 1,
        username: "Aryankhan",
        userImg: "avatar2",
        comment: "Best Lab Ever",
      },
      {
        id: 2,
        username: "Bushra Eman Khan",
        userImg: "avatar4",
        comment: "Do you provide home sampling?",
        reply: {
          userImg: "image1",
          username: "IDC",
          comment: "Yes Mam,We Do",
        },
      },
      {
        id: 3,
        username: "Alishbah Riaz",
        comment: "OKay",
      },
    ],
  },
  {
    id: 1,
    img: "img2",
    name: "Excel",
    description: "We Provide the most affordable and accurate medical services",

    status: "Pending",
    color: "warning",
    dueDate: "2022-10-22",
    commentsCount: 183,
    team: [
      { id: 1, img: "avatar8" },
      { id: 2, img: "avatar2", fullname: "Daniel Candles" },
    ],
    startDate: "10 Sept, 2015",
    projectDetails: {
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem",
      points: [
        "For Best Quality Service, it is necessary",
        "We Provide Home Sampling Services.",
        "We Provide Communication Services",
      ],
    },
    files: [
      {
        name: "Medical Board Health Care Certificate.Zip",
        size: "3.25 MB",
        link: "#",
      },
      { name: "PAK Sehat Certificate.Zip", size: "3.15 MB", link: "#" },
    ],
    comments: [
      {
        id: 1,
        username: "Aryankhan",
        userImg: "avatar2",
        comment: "Best Lab Ever",
      },
      {
        id: 2,
        username: "Bushra Eman Khan",
        userImg: "avatar4",
        comment: "Do you provide home sampling?",
        reply: {
          userImg: "image1",
          username: "IDC",
          comment: "Yes Mam,We Do",
        },
      },
      {
        id: 3,
        username: "Alishbah Riaz",
        comment: "OKay",
      },
    ],
  },
  {
    id: 2,
    img: "img3",
    name: "Shifa",
    description: "We Provide the most affordable and accurate medical services",

    status: "Delay",
    color: "danger",
    dueDate: "2022-10-13",
    commentsCount: 175,
    team: [
      {
        id: 1,
        img: "Null",
        name: "K",
        color: "info",
        fullname: "Kony Brafford",
      },
      { id: 2, img: "NULL", fullname: "Daniel Candles" },
    ],
    startDate: "10 Sept, 2015",
    projectDetails: {
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem",
      points: [
        "For Best Quality Service, it is necessary",
        "We Provide Home Sampling Services.",
        "We Provide Communication Services",
      ],
    },
    files: [
      {
        name: "Medical Board Health Care Certificate.Zip",
        size: "3.25 MB",
        link: "#",
      },
      { name: "PAK Sehat Certificate.Zip", size: "3.15 MB", link: "#" },
    ],
    comments: [
      {
        id: 1,
        username: "Aryankhan",
        userImg: "avatar2",
        comment: "Best Lab Ever",
      },
      {
        id: 2,
        username: "Bushra Eman Khan",
        userImg: "avatar4",
        comment: "Do you provide home sampling?",
        reply: {
          userImg: "image1",
          username: "IDC",
          comment: "Yes Mam,We Do",
        },
      },
      {
        id: 3,
        username: "Alishbah Riaz",
        comment: "OKay",
      },
    ],
  },
  {
    id: 3,
    img: "img4",
    name: "Jannat",
    description: "We Provide the most affordable and accurate medical services",

    status: "Completed",
    color: "success",
    dueDate: "2022-10-14",
    commentsCount: 202,
    team: [{ id: 1, img: "avatar4", fullname: "Janice Cole" }],
    startDate: "10 Sept, 2015",
    projectDetails: {
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem",
      points: [
        "For Best Quality Service, it is necessary",
        "We Provide Home Sampling Services.",
        "We Provide Communication Services",
      ],
    },
    files: [
      {
        name: "Medical Board Health Care Certificate.Zip",
        size: "3.25 MB",
        link: "#",
      },
      { name: "PAK Sehat Certificate.Zip", size: "3.15 MB", link: "#" },
    ],
    comments: [
      {
        id: 1,
        username: "Aryankhan",
        userImg: "avatar2",
        comment: "Best Lab Ever",
      },
      {
        id: 2,
        username: "Bushra Eman Khan",
        userImg: "avatar4",
        comment: "Do you provide home sampling?",
        reply: {
          userImg: "image1",
          username: "IDC",
          comment: "Yes Mam,We Do",
        },
      },
      {
        id: 3,
        username: "Alishbah Riaz",
        comment: "OKay",
      },
    ],
  },
  {
    id: 4,
    img: "img5",
    name: "Hawaa",
    description: "We Provide the most affordable and accurate medical services",

    status: "Completed",
    color: "success",
    dueDate: "2022-10-13",
    commentsCount: 194,
    team: [
      { id: 1, img: "avatar1", fullname: "Jennifer Walker" },
      { id: 2, img: "avatar4", fullname: "Daniel Candel" },
      { id: 3, img: "Null", name: "3+", color: "danger" },
    ],
    startDate: "10 Sept, 2015",
    projectDetails: {
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem",
      points: [
        "For Best Quality Service, it is necessary",
        "We Provide Home Sampling Services.",
        "We Provide Communication Services",
      ],
    },
    files: [
      {
        name: "Medical Board Health Care Certificate.Zip",
        size: "3.25 MB",
        link: "#",
      },
      { name: "PAK Sehat Certificate.Zip", size: "3.15 MB", link: "#" },
    ],
    comments: [
      {
        id: 1,
        username: "Aryankhan",
        userImg: "avatar2",
        comment: "Best Lab Ever",
      },
      {
        id: 2,
        username: "Bushra Eman Khan",
        userImg: "avatar4",
        comment: "Do you provide home sampling?",
        reply: {
          userImg: "image1",
          username: "IDC",
          comment: "Yes Mam,We Do",
        },
      },
      {
        id: 3,
        username: "Alishbah Riaz",
        comment: "OKay",
      },
    ],
  },
  {
    id: 5,
    img: "img6",
    name: "Aasmaan",
    description: "We Provide the most affordable and accurate medical services",

    status: "Pending",
    color: "warning",
    dueDate: "2022-10-24",
    commentsCount: 222,
    team: [
      { id: 1, img: "avatar4", fullname: "Janice Cole" },
      { id: 2, img: "avatar5", fullname: "Steve Foster" },
    ],
    startDate: "10 Sept, 2015",
    projectDetails: {
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem",
      points: [
        "For Best Quality Service, it is necessary",
        "We Provide Home Sampling Services.",
        "We Provide Communication Services",
      ],
    },
    files: [
      {
        name: "Medical Board Health Care Certificate.Zip",
        size: "3.25 MB",
        link: "#",
      },
      { name: "PAK Sehat Certificate.Zip", size: "3.15 MB", link: "#" },
    ],
    comments: [
      {
        id: 1,
        username: "Aryankhan",
        userImg: "avatar2",
        comment: "Best Lab Ever",
      },
      {
        id: 2,
        username: "Bushra Eman Khan",
        userImg: "avatar4",
        comment: "Do you provide home sampling?",
        reply: {
          userImg: "image1",
          username: "IDC",
          comment: "Yes Mam,We Do",
        },
      },
      {
        id: 3,
        username: "Alishbah Riaz",
        comment: "OKay",
      },
    ],
  },
];

const options = {
  chart: {
    height: 290,
    type: "bar",
    toolbar: {
      show: !1,
    },
  },
  plotOptions: {
    bar: {
      columnWidth: "14%",
      endingShape: "rounded",
    },
  },
  dataLabels: {
    enabled: !1,
  },
  series: [
    {
      name: "Revenue",
      data: [42, 56, 40, 64, 26, 42, 56, 35, 62],
    },
  ],
  grid: {
    yaxis: {
      lines: {
        show: !1,
      },
    },
  },
  yaxis: {
    title: {
      text: "PKR (thousands)",
    },
  },
  xaxis: {
    labels: {
      rotate: -90,
    },
    categories: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
    title: {
      text: "Week",
    },
  },
  colors: ["#556ee6"],
};

const series = [
  {
    name: "Overview",
    data: [42, 56, 40, 64, 26, 42, 56, 35, 62],
  },
];

export { projects, options, series };
